import { IPolicyFulfillment } from '../model/IPolicyFulfillment'
import { IPolicyResponse } from '../model/IPolicyReponse'
import axiosInstance from '../services/apis'

export const getPolicy = async (
    policyNumber: string,
    postalCode: string,
    lang: number
) => {
    const response: IPolicyResponse = await axiosInstance.get(
        `/api/IMKPolicy/imk/GetPolicy/${policyNumber}/${postalCode}/${lang}`
    )
    return response
}

export const sendFulfillment = async (
    policyFulfillment: IPolicyFulfillment
) => {
    const response: boolean = await axiosInstance.post(
        `/api/IMKPolicy/imk/SendFF`,
        policyFulfillment
    )
    return response
}
